module.exports = __webpack_public_path__ + "img/student-report-by-locational-ternatives.1b51282e.svg";